import { Chip, styled } from '@mui/material';
import { css } from '@mui/material/styles';

export const StyledChip = styled(Chip)(
  ({ theme }) => css`
    border-radius: ${theme.spacing(12.5)};
    font-size: 0.8125rem;
    padding: ${theme.spacing(0.375)} ${theme.spacing(0.5)};
  `,
);
